const ModelRoutes = [
  // 设备模型管理
  {
    path: 'device-model/:id?',
    name: 'DeviceModel',
    component: () => import(/* webpackChunkName: "DeviceModel" */ '@/views/system/deviceModel'),
    meta: {
      sidebar: 2,
      authKey: ['auth_deviceModel'],
      title: 'com_sider_menu_model',
      disabled: false,
      icon: 'menu_device_model2',
      autoCollect: false,
    },
  },

  // 设备模型别名
  {
    path: 'device-model-alias',
    name: 'DeviceModelAlias',
    component: () =>
      import(/* webpackChunkName: "DeviceModel" */ '@/views/system/deviceModelAlias'),
    meta: {
      sidebar: 2,
      authKey: ['auth_deviceModel_alias'],
      title: 'com_sider_menu_model_alias',
      disabled: false,
      icon: 'menu_device_model2',
      autoCollect: false,
    },
  },
];

export default ModelRoutes;
